<div class="login-main-content" [style.background-image]="backgroundImage">
  <div class="login-container center">
    <div class="logo-center">
      <yo-infos-version [showArrow]="false" position="right" [blockMode]="true">
          <yo-svg id="login-logo-image"
                  style="width: 100%; height: 100%;"
                  [src]="'assets/images/datameal-logo.svg'"
                  [colors]="getDatamealLogoColors()"></yo-svg>
      </yo-infos-version>
    </div>

    <div class="separator-container">
    </div>

    <form (ngSubmit)="login()">
      <div class="login-input-container">
        <input name="login" placeholder="Nom d'utilisateur..."
               class="login-input-text"
               [(ngModel)]="userLogin">
      </div>

      <div class="login-input-container">
        <input name="password" class="login-input-text"
               [type]="hide ? 'password' : 'text'"
               placeholder="Mot de passe..."
               [(ngModel)]="userPassword">
        <span class="login-icon">
          @if (hide) {
            <i class="far fa-eye cursor" (click)="hide = false"></i>
          } @else {
            <i class="far fa-eye-slash cursor" (click)="hide = true"></i>
          }
        </span>
      </div>

      <div class="login-action-container">
        <yo-button
          [buttonId]="'login-button'"
          [theme]="ButtonThemeEnum.VALIDATE"
          class="login-button"
          label="Se connecter"
          type="submit"
          [disabled]="loading">
        </yo-button>
        @if (loading) {
          <i class="fas fa-sync-alt speed-spin login-loading"></i>
        }
        <a title="Mot de passe oublié"
           (click)="openDialogMotDePasseOublie()">
          Mot de passe oublié ?
        </a>
      </div>

      @if (authInfos.length > 0) {
        <div class="separator-container">
          <span class="separator-text">ou</span>
        </div>

        @for (connexion of authInfos; track connexion.id) {
          <div class="login-action-container">
            <yo-button [label]="connexion.libelle"
                       [buttonId]="'external-login-button'"
                       [theme]="ButtonThemeEnum.VALIDATE"
                       class="login-button"
                       [disabled]="loading"
                       (onClick)="performSsoLogin(connexion)">
            </yo-button>
          </div>
        }
      }
    </form>
  </div>
  <span class="heart-icon easter-egg">Fait à Montpellier avec ❤️</span>
</div>

<!--DIALOG MOT DE PASSE OUBLIE-->
<yo-mot-de-passe-oublie></yo-mot-de-passe-oublie>
